<template>
  <div
    id="ooo_banner"
    class="has-background-primary-light has-text-primary font-bold p-2 rounded-full is-flex is-align-items-center is-justify-content-center"
  >
    <p>{{ client.attributes.ooo_note || $t('client.labels.outOfOffice') }}</p>
  </div>
</template>

<script setup>
import 'vue';

defineProps({
  client: { type: Object, required: true },
  profile: { type: Object, required: true },
});
</script>
